module.exports = __webpack_public_path__ + "static/img/mcaudience.c0cf9c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/mcaudience.svg
// module id = gTFc
// module chunks = 13